import { CheckboxFieldUI } from '@axo/form/feature/form-input/CheckboxField/CheckboxFieldUI';
import type { IFieldOptions } from '@axo/form/feature/form-input/types';
import { useTranslation } from '@axo/shared/i18n';
import { MarketCountryCode } from '@axo/shared/types';
import { Text } from '@axo/ui-core/components/typography';
import { ReactElement, useMemo, useState } from 'react';
import { Trans } from 'react-i18next';
import { useAxoFormContext } from '../../../../context/AxoForm/AxoForm';
import { TermsAndConditionsType } from '../../@types';
import { InnerConsentProps } from '../../Consent';
import styles from '../../Consent.module.scss';
import { TermsModal } from '../TermsModal';

export const CreditCheck = ({
  external,
  terms,
  options,
  hasDescriptionArea,
}: InnerConsentProps & {
  options?: IFieldOptions;
  hasDescriptionArea?: boolean;
}): ReactElement => {
  const { t } = useTranslation();

  const [selectedTerm, setSelectedTerm] = useState<TermsAndConditionsType>();

  const { marketCountry } = useAxoFormContext();

  const creditComponents = useMemo(() => {
    // TODO: Remove when the new consent config is the default
    if (!external) {
      if (marketCountry === MarketCountryCode.Finland) {
        return [
          // content is set on the translation
          // eslint-disable-next-line jsx-a11y/anchor-has-content
          <a
            key="link"
            href="https://www.axolaina.fi/asiakastieto-kyselyjarjestelma"
            target="_blank"
            rel="noreferrer"
          />,
        ];
      }
    }

    return [
      <button
        className={styles.term}
        onClick={(e) => {
          e.preventDefault();
          setSelectedTerm('CREDIT_STATUS');
        }}
        tabIndex={1}
        data-testid={'credit-status-button'}
      />,
    ];
  }, [external, marketCountry]);

  return (
    <>
      <CheckboxFieldUI
        name={'LoanApplication/CreditStatusConsent'}
        data-testid="credit-consent-checkbox"
        className={styles.credit}
        {...options}
      >
        <Trans
          i18nKey={'Consent.credit.label'}
          t={t}
          components={creditComponents}
        />
      </CheckboxFieldUI>

      {hasDescriptionArea && (
        <div className={styles.textarea}>
          <Text
            as="p"
            size="s"
            dangerouslySetInnerHTML={{
              __html: t('Consent.credit.description'),
            }}
          />
        </div>
      )}

      {selectedTerm && (
        <TermsModal
          term={selectedTerm}
          terms={terms}
          onClick={() => setSelectedTerm(undefined)}
        />
      )}
    </>
  );
};
